import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ServiceTemplateScheduleRow } from "../serviceTemplateSchedulesViewConfig";
import { formatCloseTemplateDateRange } from "../formatCloseTemplateDateRange";

/**
 * Renders the schedule's next SCHEDULED occurrence's service start/end dates
 * (nextServiceStartDate/nextServiceEndDate — see `getNextOccurrenceDatesByScheduleIds`)
 * as a single compact period, using formatExactDateRangePeriod (via
 * formatCloseTemplateDateRange) to collapse an exact month/quarter/year range
 * down to e.g. "January 2026" instead of "Jan 1, 2026 – Jan 31, 2026". Dash
 * when neither date is set. Group rows always dash — the value differs per
 * child schedule.
 */
export const ServiceTemplateScheduleNextServicePeriodCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, ServiceTemplateScheduleRow, unknown>) => {
        if (row.original.rowType === "group") {
            return (
                <ViewTableCell>
                    <span>-</span>
                </ViewTableCell>
            );
        }

        const { nextServiceStartDate, nextServiceEndDate } = row.original;

        return (
            <ViewTableCell>
                <span>
                    {formatCloseTemplateDateRange(
                        nextServiceStartDate ?? null,
                        nextServiceEndDate ?? null,
                    )}
                </span>
            </ViewTableCell>
        );
    },
);

ServiceTemplateScheduleNextServicePeriodCell.displayName =
    "ServiceTemplateScheduleNextServicePeriodCell";
